export const Types = {
  SAVE_LIST_PRODUCT: 'SAVE_LIST_PRODUCT',
  UPDATE_LIST_PRODUCT_ADD: 'UPDATE_LIST_PRODUCT_ADD',
  SAVE_DETAIL_PRODUCT: 'SAVE_DETAIL_PRODUCT',
  SAVE_LIST_PRODUCT_CREATE : 'SAVE_LIST_PRODUCT_CREATE'
}
